import { Navigate } from 'react-router';
import { CircularProgress, Box } from '@mui/material';
import { useAuth } from './useAuth';

/**
 * Guard for admin-only routes. Non-admin users are redirected to /projects.
 *
 * Defense-in-depth partner: `firestore.rules` are the ultimate gate on admin writes.
 * The sidebar already hides admin nav items; this guard covers deep-link / bookmark access.
 */
export function RequireAdmin({ children }: { children: React.ReactNode }) {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <CircularProgress />
      </Box>
    );
  }

  if (!user?.roles.includes('admin')) {
    return <Navigate to="/projects" replace />;
  }

  return <>{children}</>;
}
